import React from "react";
import { Route, Switch } from "react-router-dom";
import LoginRoute from "./login";
import RegisterRoute from "./register";
import ValidateRoute from "./validate";
import AttachRoute from "./attach";
import CallbackRoute from "./callback";
import ForgotRoute from "./forgot";
import ResetRoute from "./reset";
import HomeRoute from "./home";

export function Content() {
  return (
    <Switch>
      <Route path={`/auth/login`} component={LoginRoute} />
      <Route path={`/auth/register`} component={RegisterRoute} />
      <Route path={`/auth/validate`} component={ValidateRoute} />
      <Route path={`/auth/attach`} component={AttachRoute} />
      <Route path={`/auth/callback`} component={CallbackRoute} />
      <Route path={`/auth/forgot`} component={ForgotRoute} />
      <Route path={`/auth/reset`} component={ResetRoute} />
      <Route path={`/auth`} component={HomeRoute} />
    </Switch>
  );
}

